import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from '@routingModule';
import { SharedModule } from '../../../shared/shared.module';
import { MaterialModule } from '@modules/material.module';
import { PrimengModule } from '@modules/primeng.module';

import { TemplateModeloVistoriaComponent } from './components/template-modelo-vistoria.component';
import { CamposModeloVistoriaComponent } from './components/campos-modelo-vistoria/campos-modelo-vistoria.component';
import { TemplateModeloVistoriaResolver } from './template-modelo-vistoria.resolver';
import { VistoriaSharedModule } from '../shared/vistoria-shared.module';

@NgModule({
  declarations: [
    TemplateModeloVistoriaComponent,
    CamposModeloVistoriaComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
    PrimengModule,
    VistoriaSharedModule,
  ],
  providers: [
    TemplateModeloVistoriaResolver,
  ],
})
export class TemplateModeloVistoriaModule { }
